/**
 * Formatting utilities for display.
 */

/**
 * Convert minutes to h:mm display format.
 * @param {number} mins - Total minutes
 * @returns {string} e.g. "2:15"
 */
export function minsToHMM(mins) {
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return `${h}:${String(m).padStart(2, '0')}`;
}

/**
 * Parse a time string to total minutes.
 * Accepts two formats:
 *   - Decimal hours: "1.5" → 90 mins (contains ".")
 *   - h:mm: "1:30" → 90 mins (contains ":")
 * @param {string} str
 * @returns {number} Total minutes
 */
export function hmmToMins(str) {
  if (!str) return 0;
  const s = String(str).trim();
  if (s.includes('.')) {
    return Math.round(parseFloat(s) * 60);
  }
  const [h, m] = s.split(':').map(Number);
  return (h || 0) * 60 + (m || 0);
}

/**
 * Convert minutes to decimal hours string.
 * @param {number} mins
 * @returns {string} e.g. "1.50"
 */
export function minsToDecimal(mins) {
  if (!mins) return '0.00';
  return (mins / 60).toFixed(2);
}

/**
 * Format a date as dd/MM/yyyy (UK format).
 * @param {string|Date} date
 * @returns {string}
 */
export function formatDateUK(date) {
  const d = new Date(date);
  return d.toLocaleDateString('en-GB');
}

/**
 * Map fuel level enum to human-readable label.
 * @param {string} level - e.g. "THREE_QUARTER"
 * @returns {string} e.g. "3/4"
 */
const FUEL_LABELS = {
  FULL: 'Full',
  THREE_QUARTER: '3/4',
  TWO_THIRD: '2/3',
  HALF: '1/2',
  ONE_THIRD: '1/3',
  QUARTER: '1/4',
  EMPTY: 'Empty',
};

export function fuelLabel(level) {
  return FUEL_LABELS[level] || level || '—';
}

/**
 * Format currency in GBP.
 * @param {number} amount
 * @returns {string} e.g. "£150.00"
 */
export function formatGBP(amount) {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
  }).format(amount);
}
